module.exports = __webpack_public_path__ + "img/vcip_it_admin.847d2c61.svg";